<!-- Anzeige der Announcement-ID -->
{{ data().id }}
